/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_In_Reason_Return_From_OrderInputs */

const vi_pkl_in_reason_return_from_order = /** @type {(inputs: Pkl_In_Reason_Return_From_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả từ khách trả đơn`)
};

/**

* @param {Pkl_In_Reason_Return_From_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_in_reason_return_from_order = /** @type {((inputs?: Pkl_In_Reason_Return_From_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_In_Reason_Return_From_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_in_reason_return_from_order(inputs)
});